import { render, staticRenderFns } from "./_book.vue?vue&type=template&id=ea51f770"
import script from "./_book.vue?vue&type=script&lang=js"
export * from "./_book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports